var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66663 14.375C7.66663 10.6701 10.67 7.66666 14.375 7.66666C18.0799 7.66666 21.0833 10.6701 21.0833 14.375C21.0833 18.0799 18.0799 21.0833 14.375 21.0833C10.67 21.0833 7.66663 18.0799 7.66663 14.375ZM18.2083 14.375C18.2083 12.2579 16.4921 10.5417 14.375 10.5417C12.2579 10.5417 10.5416 12.2579 10.5416 14.375C10.5416 16.4921 12.2579 18.2083 14.375 18.2083C16.4921 18.2083 18.2083 16.4921 18.2083 14.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8333 14.375C26.8333 10.6701 29.8367 7.66666 33.5416 7.66666C37.2465 7.66666 40.25 10.6701 40.25 14.375C40.25 18.0799 37.2465 21.0833 33.5416 21.0833C29.8367 21.0833 26.8333 18.0799 26.8333 14.375ZM37.375 14.375C37.375 12.2579 35.6587 10.5417 33.5416 10.5417C31.4245 10.5417 29.7083 12.2579 29.7083 14.375C29.7083 16.4921 31.4245 18.2083 33.5416 18.2083C35.6587 18.2083 37.375 16.4921 37.375 14.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66663 33.5417C7.66663 29.8367 10.67 26.8333 14.375 26.8333C18.0799 26.8333 21.0833 29.8367 21.0833 33.5417C21.0833 37.2466 18.0799 40.25 14.375 40.25C10.67 40.25 7.66663 37.2466 7.66663 33.5417ZM18.2083 33.5417C18.2083 31.4246 16.4921 29.7083 14.375 29.7083C12.2579 29.7083 10.5416 31.4246 10.5416 33.5417C10.5416 35.6587 12.2579 37.375 14.375 37.375C16.4921 37.375 18.2083 35.6587 18.2083 33.5417Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8333 33.5417C26.8333 29.8367 29.8367 26.8333 33.5416 26.8333C37.2465 26.8333 40.25 29.8367 40.25 33.5417C40.25 37.2466 37.2465 40.25 33.5416 40.25C29.8367 40.25 26.8333 37.2466 26.8333 33.5417ZM37.375 33.5417C37.375 31.4246 35.6587 29.7083 33.5416 29.7083C31.4245 29.7083 29.7083 31.4246 29.7083 33.5417C29.7083 35.6587 31.4245 37.375 33.5416 37.375C35.6587 37.375 37.375 35.6587 37.375 33.5417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressCheckIcon);
export default __webpack_public_path__ + "static/media/addressCheckIcon.aa3cf1105d95d18d90df934bd294a688.svg";
export { ForwardRef as ReactComponent };